import { useContext } from "react";

import { BotsContext } from "../contexts/bots/BotsContext";

const useBots = () => useContext(BotsContext);

export default useBots;
